module.exports = __webpack_public_path__ + "img/shchesscom.fca22b33.png";